<div class="file-page-filters with-three-buttons">
    <core-helpers-box-loading [hidden]="imgLoaded"></core-helpers-box-loading>
    <div class="fieldset fieldset-top" *ngIf="imgLoaded && (filtered || crop.move)">
        <core-helpers-forms-button [text]="'Reset'" (submit)="resetFilters()" [disabled]="!filtered"></core-helpers-forms-button>
        <core-helpers-forms-button [text]="'Crop'" (submit)="submitEvent('crop')" [disabled]="crop.resizing || !crop.cropping || exclude.excluded"></core-helpers-forms-button>
        <core-helpers-forms-button [text]="'Exclude'" (submit)="submitEvent('exclude')" [disabled]="crop.resizing || !crop.cropping || exclude.excluded"></core-helpers-forms-button>
    </div>
    <div *ngIf="imgLoaded" class="filter-wrapper">

        <div class="container"
             [ngStyle]="styles.container"
             coreSizeMe
             [monitorWidth]="true"
             (resize)="onResizeArea($event)"
             (mousemove)="onSelectCrop($event)"
             (mouseup)="endSelectCrop($event)"
             (touchmove)= "onSelectCrop($event)"
             (touchend) ="endSelectCrop($event)"
        >
            <div class="image" [ngClass]="{loading: !this.imgFullLoaded}"
                [style.backgroundImage]="'url('+ urlImage +')'"
                [ngStyle]="styles.area"

            >
<!--  mousedown, mousemove y mouseup POR  touchstart, touchmove y touchend -->

            </div>
            <!-- EXCLUDE -->
            <div *ngFor="let exclude of excludes" class="exclude-area" [ngStyle]="exclude"></div>
            <!-- crop -->
            <span (mousedown)="selectorSelectCrop('tl')" (touchstart)="selectorSelectCrop('tl')" [ngStyle]="crop.selector.tl.style"><em></em></span>
            <span (mousedown)="selectorSelectCrop('tr')" (touchstart)="selectorSelectCrop('tr')" [ngStyle]="crop.selector.tr.style"><em></em></span>
            <span (mousedown)="selectorSelectCrop('bl')" (touchstart)="selectorSelectCrop('bl')" [ngStyle]="crop.selector.bl.style"><em></em></span>
            <span (mousedown)="selectorSelectCrop('br')" (touchstart)="selectorSelectCrop('br')" [ngStyle]="crop.selector.br.style"><em></em></span>
            <div
                [hidden]="!imgLoaded"
                class="crop-area"
                [ngStyle]="crop.area.style"
            >
            </div>

        </div>

    </div>
    <div class="fieldset fieldset-bottom" *ngIf="imgLoaded && (crop.cropping || crop.cropped || exclude.excluded) && crop.move">
        <core-helpers-forms-button [text]="'Reset'" (submit)="resetCrop()" [disabled]="!crop.cropped"></core-helpers-forms-button>
        <core-helpers-forms-button [text]="'Crop'" (submit)="submitEvent('crop')" [disabled]="crop.resizing || !crop.cropping "></core-helpers-forms-button>
        <core-helpers-forms-button [text]="'Exclude'" (submit)="submitEvent('exclude')" [disabled]="crop.resizing || !crop.cropping"></core-helpers-forms-button>
    </div>
</div>
